import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  AyotayoCheckBox,
  CheckBox,
  FormSelect,
  FormTemplate,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  AddVendorDepartments,
  GetAllDepartments,
  GetSingleVendor,
} from "../../../../../utils/redux/Vendor/VendorSlice";
// this
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
// import { CheckMarks } from "./ViewVendors";
import { useParams } from "react-router";
import { toast } from "react-toastify";

function SetUpVendor(props) {
  const { openModal, setOpenModal, vendor } = props;

  const dispatch = useDispatch();

  const { all_departments, isLoadingAction } = useSelector(
    (state) => state?.vendor
  );

  useEffect(() => {
    dispatch(GetAllDepartments());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppModalTemplate
      padding={"0px"}
      width={"500px"}
      isOpen={openModal}
      setIsOpen={setOpenModal}
    >
      <NewCreateCategoryActions
        vendor={vendor}
        all_departments={all_departments}
        // category={consummableSetUp}
        isOpen={openModal}
        setIsOpen={setOpenModal}
        isLoadingAction={isLoadingAction}
      />
    </AppModalTemplate>
  );
}

export default SetUpVendor;

export function NewCreateCategoryActions({
  isOpen,
  setIsOpen,
  category,
  isLoadingAction,
  all_departments,
  vendor,
}) {
  // console.log("vendor", vendor);
  const prefilledManaging = vendor?.managingDepartment?.map((x) => x);

  const prefilledUsers = vendor?.userDepartment?.reduce(
    (lookup, value) => ({
      ...lookup,
      [value?.name]: value?.name,
    }),
    {}
  );

  const defaultData = {
    userDepartments: prefilledUsers,
    managingDepartmentId: prefilledManaging?.[0]?.id,
    managingDepartmentUnit: prefilledManaging?.[0]?.departmentUnit?.id,
  };

  const getManagingUnits = all_departments?.responseObject?.pageItems?.find(
    (x) => defaultData?.managingDepartmentId === x?.id
  );

  // console.log("defaultData", getManagingUnits);
  // console.log("defaultData", defaultData);

  const [units, setUnits] = useState(getManagingUnits || {});
  const [departmentDetails, setDepartmentDetails] = useState({});
  const dispatch = useDispatch();
  const { id } = useParams();

  // console.log({ units, departmentDetails });

  const formMethods = useForm({
    defaultValues: defaultData,
    mode: "all",
  });

  const { handleSubmit } = formMethods;
  const submit = (data) => {
    const userDepartments = Object.keys(data?.userDepartments)
      .filter((key) => data?.userDepartments[key])
      .map((key) => {
        return {
          name: key,
          id: all_departments?.responseObject?.pageItems?.find(
            (department) => department?.name === key
          )?.id,
        };
      });

    const getHocId = Object.keys(data?.userDepartments)
      .filter((key) => data?.userDepartments[key])
      .map((key) => {
        return {
          name: key,
          id: all_departments?.responseObject?.pageItems?.find(
            (department) => department?.name === key
          ),
          hocId: all_departments?.responseObject?.pageItems?.find(
            (department) => department?.name === key
          ),
        };
      });

    // console.log(getHocId);

    const eachDataById = all_departments?.responseObject?.pageItems?.find(
      (x) => +data?.managingDepartmentId === x?.id
    );

    const hou = units?.containers?.find(
      (container) =>
        container?.name === departmentDetails?.departmentUnit?.name ||
        container?.name === prefilledManaging?.[0]?.departmentUnit?.name
    );

    const appData = {
      vendorId: +id,
      userDepartments,
      managingDepartments: [
        {
          id: +data?.managingDepartmentId,
          name:
            departmentDetails?.managingDepartments?.name ||
            prefilledManaging?.[0]?.name,
          hodId: eachDataById?.hodId,
          departmentUnit: {
            id: +data?.managingDepartmentUnit,
            name:
              departmentDetails?.departmentUnit?.name ||
              prefilledManaging?.[0]?.departmentUnit?.name,
            houId: hou?.hocId,
          },
        },
      ],
    };

    // console.log(appData);

    return dispatch(AddVendorDepartments(appData))?.then((res) => {
      if (res?.payload?.successful === true) {
        toast.success(res?.payload?.statusMessage, {
          autoClose: true,
          style: { zIndex: 9999990 },
        });
        dispatch(GetSingleVendor({ id }));
        setIsOpen(!isOpen);
      } else {
        toast.error(res?.payload?.statusMessage, {
          autoClose: true,
          style: { zIndex: 9999990 },
        });
      }
    });
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <h4>Setup Account</h4>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <section
                style={{ gridTemplateColumns: "1fr", padding: "0.5rem" }}
                className={DashboardStyle.form_section}
              >
                <div
                  style={{ padding: "1rem", gridTemplateColumns: "1fr" }}
                  className={DashboardStyle.inputs_group_no_grid}
                >
                  <div style={{ gridTemplateColumns: "1fr" }}>
                    <FormSelect
                      title={"Managing Department"}
                      camelCase={"managingDepartmentId"}
                      placeholder={"select"}
                      array={all_departments?.responseObject?.pageItems?.map?.(
                        (x, index) => (
                          <option key={index} value={x?.id}>
                            {x?.name}
                          </option>
                        )
                      )}
                      moreRegister={{
                        onChange: (e) => {
                          const isFound =
                            all_departments?.responseObject?.pageItems?.find(
                              (x) => +e.target.value === x?.id
                            );

                          setUnits(isFound);
                          setDepartmentDetails({
                            ...departmentDetails,
                            managingDepartments: isFound,
                          });
                        },
                      }}
                    />
                  </div>
                  <div style={{ gridTemplateColumns: "1fr" }}>
                    <FormSelect
                      title={"Unit"}
                      camelCase={"managingDepartmentUnit"}
                      placeholder={"select"}
                      arrayLenghtNotice={
                        "No Available Units, Select A Managing Department with Units"
                      }
                      array={units?.containers?.map?.((x, index) => (
                        <option key={index} value={x?.id}>
                          {x?.name}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          const isFound = units?.containers?.find(
                            (x) => +e.target.value === x?.id
                          );
                          setDepartmentDetails({
                            ...departmentDetails,
                            departmentUnit: isFound,
                          });
                        },
                      }}
                    />
                  </div>
                  <div>
                    <p
                      style={{
                        marginTop: "0.65rem",
                        color: "var(--form_title)",
                        fontWeight: "400",
                      }}
                    >
                      User Departments <sup style={{ color: "red" }}>*</sup>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {all_departments?.responseObject?.pageItems &&
                        all_departments?.responseObject?.pageItems?.map(
                          (state, index) => {
                            return (
                              <AyotayoCheckBox
                                key={state?.name || index}
                                isRequired={false}
                                camelCase={`userDepartments`}
                                name={state?.name}
                                value={state?.name}
                                style={{ flex: "1 1 auto", margin: "5px" }}
                              />
                            );
                          }
                        )}
                    </div>
                  </div>

                  {/* <div>
                    <p
                      style={{
                        marginTop: "0.65rem",
                        color: "var(--form_title)",
                        fontWeight: "400",
                      }}
                    >
                      User Departments <sup style={{ color: "red" }}>*</sup>
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                      }}
                    >
                      {all_departments?.responseObject?.pageItems &&
                        all_departments?.responseObject?.pageItems?.map(
                          (state, index) => {
                            console.log(state)
                            return (
                              <CheckBox
                                key={state?.name || index}
                                isRequired={false}
                                camelCase={`userDepartments`}
                                name={state?.name}
                                value={state?.name}
                                group={`managingDepartments.${state?.name}`}
                                style={{
                                  flex: "1 1 auto",
                                  margin: "5px", // Adjust this value as needed
                                }}
                              />
                            );
                          }
                        )}
                        
                    </div>{" "}
                  </div> */}
                </div>
              </section>
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <SupportButtons
                  width={"auto"}
                  onClick={() => setIsOpen(!isOpen)}
                  className={DashboardStyle?.button_cage_weight_without_border}
                >
                  No, Cancel
                </SupportButtons>
                <ActionButtons
                  isLoading={isLoadingAction}
                  // disabled={!isValid}
                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Submit
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
